<template>
  <svg
    class="donut"
    :height="size"
    :width="size"
    :viewBox="`0 0 ${size} ${size}`"
    preserveAspectRatio="xMidYMid meet"
  >
    <circle
      class="donut__circle"
      :r="radius"
      cx="50%"
      cy="50%"
      stroke="#EBEBEB"
      :stroke-width="border"
    ></circle>
    <circle
      class="donut__circle"
      :r="radius"
      cx="50%"
      cy="50%"
      :stroke="stroke"
      :stroke-width="border"
      :stroke-dasharray="dash"
      :stroke-dashoffset="offset"
    ></circle>
    <g class="donut__text" :transform="`rotate(90 ${size / 2} ${size / 2})`">
      <text text-anchor="middle" alignment-baseline="middle" x="50%" y="50%">
        {{ percentage }} %
      </text>
    </g>
  </svg>
</template>
<style scoped>
.donut {
  fill: transparent;
  transform: rotate(-90deg);
  flex-shrink: 0;
}

.donut__circle {
  transition: 0.3s stroke-dashoffset;
  will-change: stroke-dashoffset;
}

.donut__text {
  fill: #777;
  font-weight: 600;
}
</style>
<script>
export default {
  name: 'donut',
  props: {
    size: {
      type: Number,
      default: 61
    },
    border: {
      type: Number,
      default: 5
    },
    usage: {
      type: Number,
      required: true,
      validator: value => !!(value >= 0 && value <= 100)
    }
  },
  computed: {
    percentage() {
      return Math.min(Math.max(0, this.usage), 100);
    },
    radius() {
      return this.size / 2 - this.border / 2;
    },
    dash() {
      return Math.PI * (this.radius * 2);
    },
    offset() {
      return ((100 - this.percentage) / 100) * this.dash;
    },
    stroke() {
      return this.usage === 100 ? '#38B2AC' : '#3182CE';
    }
  }
};
</script>
